export default __webpack_public_path__ + "static/media/10_AIDC.b3e97d64.png";